import React from 'react';

const Privacy = () => (
    <div style={{margin:'10px',padding:'10px'}}>
        <h1>Privacy Policy</h1>
        <p style={{fontSize:"20px"}}>
        We may use the information we collect for various purposes, including to: provide the services to you and improve the quality of the service. We collect information that you provide when you place an order, register with us, send us an e-mail or call us. This information may include the following: Your name, Your mailing address, Your e-mail address, Your phone number. It may also include information you submit about the recipients. We do not share your information with third parties without any legal reasons.
        </p>
    </div>
)
export default Privacy;